import React, { useState, useEffect } from 'react';
import './LoginPage.css';

const ChangePassword = ({ 
  initialUsername, 
  onClose,
  darkMode
}) => {
  // 修改密码相关状态
  const [formData, setFormData] = useState({
    username: initialUsername,
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [apiError, setApiError] = useState('');

  // 当初始用户名变化时更新表单
  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      username: initialUsername
    }));
  }, [initialUsername]);

  // 处理表单变化
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null
      });
    }
    
    if (apiError) setApiError('');
  };

  // 表单验证
  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.username.trim()) {
      newErrors.username = '请输入账号';
    }
    
    if (!formData.currentPassword) {
      newErrors.currentPassword = '请输入当前密码';
    }
    
    if (!formData.newPassword) {
      newErrors.newPassword = '请输入新密码';
    } 
    
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = '请确认新密码';
    } else if (formData.confirmPassword !== formData.newPassword) {
      newErrors.confirmPassword = '两次输入的密码不一致';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 处理表单提交
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      setIsLoading(true);
      setApiError('');
      
      try {
        const response = await fetch('http://10.40.93.94:8077/api/auth-logs/updatepsw', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            username: formData.username,
            password: formData.currentPassword,
            newPassword: formData.newPassword
          })
        });
        
        const data = await response.json();
        
        if (!response.ok) {
          throw new Error(data.message || '修改密码请求失败');
        }
        
        if (data.code === 0) {
          setIsSuccess(true);
          // 3秒后自动关闭弹窗
          setTimeout(() => {
            onClose();
            // 重置表单
            setFormData({
              username: initialUsername,
              currentPassword: '',
              newPassword: '',
              confirmPassword: ''
            });
            setIsSuccess(false);
          }, 3000);
        } else {
          setApiError(data.message || '修改密码失败，请检查输入信息');
        }
      } catch (error) {
        setApiError(error.message || '修改密码失败，请稍后再试');
      } finally {
        setIsLoading(false);
      }
    }
  };

  // 关闭弹窗前重置状态
  const handleClose = () => {
    setFormData({
      username: initialUsername,
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
    setErrors({});
    setApiError('');
    setIsSuccess(false);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className={`change-password-modal ${darkMode ? 'dark-mode' : ''}`}>
        <div className="modal-header">
          <h3>修改密码</h3>
          <button className="close-button" onClick={handleClose}aria-label="关闭弹窗">
            x
          </button>
        </div>
        
        <form className="change-password-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="change-username">账号</label>
            <div className={`input-container ${errors.username ? 'error' : ''}`}>
              <i className="fas fa-user"></i>
              <input
                type="text"
                id="change-username"
                name="username"
                placeholder="请输入账号"
                value={formData.username}
                onChange={handleChange}
                disabled={isLoading || isSuccess}
              />
            </div>
            {errors.username && <div className="error-message">{errors.username}</div>}
          </div>
          
          <div className="form-group">
            <label htmlFor="current-password">当前密码</label>
            <div className={`input-container ${errors.currentPassword ? 'error' : ''}`}>
              <i className="fas fa-lock"></i>
              <input
                type="password"
                id="current-password"
                name="currentPassword"
                placeholder="请输入当前密码"
                value={formData.currentPassword}
                onChange={handleChange}
                disabled={isLoading || isSuccess}
              />
            </div>
            {errors.currentPassword && <div className="error-message">{errors.currentPassword}</div>}
          </div>
          
          <div className="form-group">
            <label htmlFor="new-password">新密码</label>
            <div className={`input-container ${errors.newPassword ? 'error' : ''}`}>
              <i className="fas fa-key"></i>
              <input
                type="password"
                id="new-password"
                name="newPassword"
                placeholder="请输入新密码"
                value={formData.newPassword}
                onChange={handleChange}
                disabled={isLoading || isSuccess}
              />
            </div>
            {errors.newPassword && <div className="error-message">{errors.newPassword}</div>}
          </div>
          
          <div className="form-group">
            <label htmlFor="confirm-password">确认新密码</label>
            <div className={`input-container ${errors.confirmPassword ? 'error' : ''}`}>
              <i className="fas fa-key"></i>
              <input
                type="password"
                id="confirm-password"
                name="confirmPassword"
                placeholder="请再次输入新密码"
                value={formData.confirmPassword}
                onChange={handleChange}
                disabled={isLoading || isSuccess}
              />
            </div>
            {errors.confirmPassword && <div className="error-message">{errors.confirmPassword}</div>}
          </div>
          
          {apiError && <div className="api-error-message">{apiError}</div>}
          
          <div className="modal-actions">
            <button 
              type="button" 
              className="cancel-button"
              onClick={handleClose}
              disabled={isLoading}
            >
              取消
            </button>
            <button 
              type="submit" 
              className={`confirm-button ${isSuccess ? 'success' : ''}`}
              disabled={isLoading || isSuccess}
            >
              {isLoading ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i> 修改中...
                </>
              ) : isSuccess ? (
                <>
                  <i className="fas fa-check"></i> 修改成功
                </>
              ) : "确认修改"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;